import { render, staticRenderFns } from "./RightToolBarPlus.vue?vue&type=template&id=5f28d50a&scoped=true"
import script from "./RightToolBarPlus.vue?vue&type=script&lang=js"
export * from "./RightToolBarPlus.vue?vue&type=script&lang=js"
import style0 from "./RightToolBarPlus.vue?vue&type=style&index=0&id=5f28d50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28d50a",
  null
  
)

export default component.exports